import type { ConceptDef } from '../types';

export const letterSoundId: ConceptDef = {
  kind: 'tileMatch',
  id: 'letter-sound-id',
  label: 'Letter Sound ID',
  category: 'Literacy',
  description: 'Hear a letter sound; tap the letter that makes it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'the buh sound', answer: 'B' },
      { say: 'the mmm sound', answer: 'M' },
      { say: 'the sss sound', answer: 'S' },
      { say: 'the tuh sound', answer: 'T' },
      { say: 'the puh sound', answer: 'P' },
      { say: 'the kuh sound', answer: 'K' },
    ],
  },
};
